import React, { useState } from 'react';
import { faqData } from '../data/faqData';
import PageWrapper from "../components/PageWrapper";

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <PageWrapper>
            <div
                className="py-12 sm:py-16 min-h-screen"
                style={{
                    backgroundImage: `url('/gradient_bg.svg'), linear-gradient(to bottom, #0ea5e9, #ffffff 50%, #ffffff)`,
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundSize: "cover, cover",
                    backgroundPosition: "center, center",
                }}
            >
                <div className="mx-auto max-w-3xl px-6 lg:px-8">
                    {/* Header Section */}
                    <h2 className="text-center text-base font-semibold text-sky-600 font-heading">
                        FAQ
                    </h2>
                    <h3 className="mx-auto mt-2 max-w-lg text-balance text-center text-2xl font-semibold tracking-tight text-gray-950 font-heading">
                        Häufig gestellte Fragen beantwortet
                    </h3>
                </div>

                <div className="max-w-2xl mx-auto mt-10">
                    <div className="hs-accordion-group">
                        {faqData.map((faq, index) => (
                            <div
                                className={`hs-accordion ${activeIndex === index ? 'hs-accordion-active:bg-gray-100' : ''
                                    } rounded-xl p-6`}
                                key={index}
                            >
                                <button
                                    className="font-body hs-accordion-toggle group pb-3 inline-flex items-center justify-between gap-x-3 w-full md:text-lg font-semibold text-start text-gray-900 rounded-lg transition hover:text-gray-500"
                                    onClick={() => toggleAccordion(index)}
                                    aria-controls={`hs-basic-with-title-and-arrow-stretched-collapse-${index}`}
                                >
                                    <span>{faq.question}</span>
                                    {activeIndex === index ? (
                                        <svg
                                            className="flex-shrink-0 size-5 text-gray-900 group-hover:text-gray-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor"
                                            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                        >
                                            <path d="m6 9 6 6 6-6" />
                                        </svg>
                                    ) : (
                                        <svg
                                            className="flex-shrink-0 size-5 text-gray-900 group-hover:text-gray-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor"
                                            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                        >
                                            <path d="m18 15-6-6-6 6" />
                                        </svg>
                                    )}
                                </button>
                                <div
                                    id={`hs-basic-with-title-and-arrow-stretched-collapse-${index}`}
                                    className={`hs-accordion-content ${activeIndex === index ? 'w-full' : 'hidden'
                                        } overflow-hidden transition-[height] duration-300`}
                                >
                                    <p className="text-gray-500 font-body">{faq.answer}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
};


export default FAQ;
